import AddConnector from "components/ConnectorType/AddConnector";
import DialogConnector from "components/ConnectorType/Model/DailogConnector";
import React, { Component } from "react";

export default class AddConnectorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      openConnector: false,
    };
  }
  openConnector = () => {
    this.setState({ open: true });
  };  
  closeConnector = () => {
    this.setState({ openConnector: false });
  };

  submitConnector = async (id, file) => {
    // var res = await this.props.postConnectorData(id);
    // if (res.status === 1) {
    //   this.handleClickOpen();
    // }
    // this.props.getAddManufacturerAction();
  };
  render() {
   
    return (
      <>
        <AddConnector
          submitConnector={(val) => this.submitConnector(val)}
          closeConnector={this.closeConnector}
          open={this.openConnector}
          openConnector={this.openConnector}
        />
        <DialogConnector
          closeConnector={this.closeConnector}
          open={this.open}
        />
      </>
    );
  }
}
